import { push } from 'react-router-redux';
import update from 'immutability-helper';
import Notifications from 'react-notification-system-redux';

import { authLoginUserFailure } from '../../../actions/auth';
import { checkHttpStatus, parseJSON } from '../../../utils';
import { fetchBooking, fetchBookings, patchBid, fetchSendBookingBid, postBidDetailsRate, updatePinUnpinStatus,patchTourStatus,getTourStatusData, addNotes, getBrandNote, changeStatus, updateContact, deleteContact } from './api';
import {
  fetchAddBidNote,
  getBidDetails,
  createAnswers,
  fetchAnswers,
} from '../../../core/api';

// ------------------------------------
// Constants
// ------------------------------------
export const BOOKING_SELECT = 'BOOKING_SELECT';
export const BID_EDIT_FAILURE = 'BID_EDIT_FAILURE';
export const BID_EDIT_REQUEST = 'BID_EDIT_REQUEST';
export const BID_EDIT_SUCCESS = 'BID_EDIT_SUCCESS';
export const BID_SEND_FAILURE = 'BID_SEND_FAILURE';
export const BID_SEND_REQUEST = 'BID_SEND_REQUEST';
export const BID_SEND_SUCCESS = 'BID_SEND_SUCCESS';
export const BIDNOTE_EDIT_FAILURE = 'BIDNOTE_EDIT_FAILURE';
export const BIDNOTE_EDIT_REQUEST = 'BIDNOTE_EDIT_REQUEST';
export const BIDNOTE_EDIT_SUCCESS = 'BIDNOTE_EDIT_SUCCESS';
export const BOOKING_FETCH_FAILURE = 'BOOKING_FETCH_FAILURE';
export const BOOKING_FETCH_REQUEST = 'BOOKING_FETCH_REQUEST';
export const BOOKING_FETCH_SUCCESS = 'BOOKING_FETCH_SUCCESS';
export const BOOKING_LIST_FETCH_FAILURE = 'BOOKING_LIST_FETCH_FAILURE';
export const BOOKING_LIST_FETCH_REQUEST = 'BOOKING_LIST_FETCH_REQUEST';
export const BOOKING_LIST_FETCH_SUCCESS = 'BOOKING_LIST_FETCH_SUCCESS';

export const TOUR_EDIT_SUCCESS = 'TOUR_EDIT_SUCCESS';
export const TOUR_EDIT_FAILURE = 'TOUR_EDIT_FAILURE';

export const UPDATE_HOTEL_CONTACT_REQUEST = 'UPDATE_HOTEL_CONTACT_REQUEST';
export const UPDATE_HOTEL_CONTACT_SUCCESS = 'UPDATE_HOTEL_CONTACT_SUCCESS';

export const DELETE_HOTEL_CONTACT_REQUEST = 'DELETE_HOTEL_CONTACT_REQUEST';
export const DELETE_HOTEL_CONTACT_SUCCESS = 'DELETE_HOTEL_CONTACT_SUCCESS';

export const ADD_NOTE_REQUEST = 'ADD_NOTE_REQUEST';
export const ADD_NOTE_SUCCESS = 'ADD_NOTE_SUCCESS';
export const ADD_NOTE_FAILURE = 'ADD_NOTE_FAILURE';

export const CHANGE_STATUS_REQUEST = 'CHANGE_STATUS_REQUEST';
export const CHANGE_STATUS_SUCCESS = 'CHANGE_STATUS_SUCCESS';
export const CHANGE_STATUS_FAILURE = 'CHANGE_STATUS_FAILURE';

export const GET_NOTE_REQUEST = 'GET_NOTE_REQUEST';
export const GET_NOTE_SUCCESS = 'GET_NOTE_SUCCESS';
export const GET_NOTE_FAILURE = 'GET_NOTE_FAILURE';

export const GET_TOUR_DATA = 'GET_TOUR_DATA';
export const GET_TOUR_DATA_FAILURE = 'GET_TOUR_DATA_FAILURE';

export const ADD_ANSWERS_REQUEST = 'ADD_ANSWERS_REQUEST';
export const ADD_ANSWERS_SUCCESS = 'ADD_ANSWERS_SUCCESS';
export const ANSWERS_ADD_FAILURE ='ANSWERS_ADD_FAILURE';

export const FETCH_ANSWERS_REQUEST = 'FETCH_ANSWERS_REQUEST';
export const FETCH_ANSWERS_SUCCESS = 'FETCH_ANSWERS_SUCCESS';
export const FETCH_ANSWERS_FAILURE = 'FETCH_ANSWERS_FAILURE';

export const BIDDETAIL_GET_REQUEST = 'BIDDETAIL_GET_REQUEST';
export const BIDDETAIL_GET_SUCCESS = 'BIDDETAIL_GET_SUCCESS';

export const PIN_UNPIN_STATUS_UPDATE_REQUEST = 'PIN_UNPIN_STATUS_UPDATE_REQUEST';
export const PIN_UNPIN_STATUS_UPDATE_SUCCESS = 'PIN_UNPIN_STATUS_UPDATE_SUCCESS';
export const PIN_UNPIN_STATUS_UPDATE_FAILURE = 'PIN_UNPIN_STATUS_UPDATE_FAILURE';
// ------------------------------------
// Actions
// ------------------------------------

function findById(value) {
  return value.id === this;
}
export function requestingAddBidNote(bid) {
  return {
    type: BIDNOTE_EDIT_REQUEST,
    payload: bid,
  };
}
export function requestAddBidNoteSuccess(json) {
  return {
    type: BIDNOTE_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestAddBidNoteFailure(json) {
  return {
    type: BIDNOTE_EDIT_FAILURE,
    payload: json,
  };
}

export function requestChangeStatus(json){
  return {
    type: CHANGE_STATUS_REQUEST,
    payload: json,
  }
}

export function requestChangeStatusSuccess(json){
  return {
    type: CHANGE_STATUS_SUCCESS,
    payload: json,
  }
}

export function requestChangeStatusFailure(json){
  return {
    type: CHANGE_STATUS_FAILURE,
    payload: json,
  }
}

export function requestAddNote(json){
  return {
    type: ADD_NOTE_REQUEST,
    payload: json,
  }
}

export function requestAddNoteSuccess(json){
  return {
    type: ADD_NOTE_SUCCESS,
    payload: json,
  }
}

export function requestAddNoteFailure(json){
  return {
    type: ADD_NOTE_FAILURE,
    payload: json,
  }
}

export function requestGetNote(json){
  return {
    type: GET_NOTE_REQUEST,
    payload: json,
  }
}

export function requestGetNoteSuccess(json){
  return {
    type: GET_NOTE_SUCCESS,
    payload: json,
  }
}

export function requestGetNoteFailure(json){
  return {
    type: GET_NOTE_FAILURE,
    payload: json,
  }
}

export function requestingBidEdit(bid) {
  return {
    type: BID_EDIT_REQUEST,
    payload: bid,
  };
}
export function requestBidEditSuccess(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestFatchAnswers(){
  return {
    type: FETCH_ANSWERS_REQUEST,
    payload: null,
  };
}

export function receiveFatchAnswers(json){
  return {
    type: FETCH_ANSWERS_SUCCESS,
    payload: json,
  };
}

export function failureFatchAnswers(){
  return {
    type: FETCH_ANSWERS_FAILURE,
    payload: null,
  };
}
export function answerAddRequest(){
  return {
    type: ADD_ANSWERS_REQUEST,
    payload : null,
  };
}

export function answerAddSuccess(){
  return {
    type: ADD_ANSWERS_SUCCESS,
    payload : null,
  }
}

export function answerAddFailure(){
  return {
    type: ANSWERS_ADD_FAILURE,
    payload: null,
  };
}

export function requestUpdateContact(json) {
  return {
    type: UPDATE_HOTEL_CONTACT_REQUEST,
    payload: json,
  };
}
export function receiveUpdateContact(json) {
  return {
    type: UPDATE_HOTEL_CONTACT_SUCCESS,
    payload: json,
  };
}
export function requestDeleteContact(json) {
  return {
    type: DELETE_HOTEL_CONTACT_REQUEST,
    payload: json,
  };
}
export function receiveDeleteContact(json) {
  return {
    type: DELETE_HOTEL_CONTACT_SUCCESS,
    payload: json,
  };
}

export function requestBidSend(json) {
  return {
    type: BID_SEND_REQUEST,
    payload: json,
  };
}
export function requestPinUnpinStatusUpdate(json) {
  return {
    type: PIN_UNPIN_STATUS_UPDATE_REQUEST,
    payload: json,
  };
}
export function requestPinUnpinStatusUpdateSuccess(json) {
  return {
    type: PIN_UNPIN_STATUS_UPDATE_SUCCESS,
    payload: json,
  };
}
export function requestPinUnpinStatusUpdateFailure(json) {
  return {
    type: PIN_UNPIN_STATUS_UPDATE_FAILURE,
    payload: json,
  };
}
export function receiveBidSend(json) {
  return {
    type: BID_EDIT_SUCCESS,
    payload: json,
  };
}
export function requestBidEditFailure(json) {
  return {
    type: BID_EDIT_FAILURE,
    payload: json,
  };
}
export function requestingBooking() {
  return {
    type: BOOKING_FETCH_REQUEST,
    payload: null,
  };
}
export function requestingBookings() {
  return {
    type: BOOKING_LIST_FETCH_REQUEST,
    payload: null,
  };
}
export function requestBookingSuccess(json) {
  return {
    type: BOOKING_FETCH_SUCCESS,
    payload: json,
  };
}
export function requestBookingsSuccess(json) {
  return {
    type: BOOKING_LIST_FETCH_SUCCESS,
    payload: json,
  };
}
export function getTourSuccess(){
  return{
    type: GET_TOUR_DATA,
    payload:null,
  }
}
export function getTourFailure(){
  return{
    type: GET_TOUR_DATA_FAILURE,
    payload:null,
  }
}
export function editTourSuccess(json) {
  return {
    type: TOUR_EDIT_SUCCESS,
    payload: json,
  };
}
export function editTourFailure(json) {
  return {
    type: TOUR_EDIT_FAILURE,
    payload: json,
  };
}
export function requestBookingFailure(json) {
  return {
    type: BOOKING_FETCH_FAILURE,
    payload: json,
  };
}
export function requestBookingsFailure(json) {
  return {
    type: BOOKING_LIST_FETCH_FAILURE,
    payload: json,
  };
}

export function getBidDetailsRequest() {
  return {
    type: BIDDETAIL_GET_REQUEST,
    payload: null,
  };
}

export function getBidDetailsSuccess(json, bid) {
  return {
    type: BIDDETAIL_GET_SUCCESS,
    payload: { data: json.results, bid: bid },
  };
}


export function requestBidDetails(bid) {
  return (dispatch) => {
    dispatch(getBidDetailsRequest());
    return getBidDetails(bid)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(getBidDetailsSuccess(response, bid))
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              dispatch(push('/login?next=/tours'));
            });
          }
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestTours()),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestToursError());
      });
  };
}

export function requestAnswers(id, cb) {
  console.log('console for testing perpose--->>',id)
  return (dispatch) => {
    dispatch(requestFatchAnswers());
    return fetchAnswers(id)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response) => {
      dispatch(receiveFatchAnswers(response));
      cb(response)
      console.log('response-->>',response)
    })
    .catch((error) =>{
      if(error){
        const status = error.response.status;
        dispatch(Notifications.error(status));
      }else {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Network Error',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(failureFatchAnswers());
    })

  }
}

export function addAnswers(payload, cb){
  return (dispatch) => {
    dispatch(answerAddRequest());
    createAnswers(payload)
    .then(checkHttpStatus)
    .then(parseJSON)
    .then((response) => {
      if(response){
        const notificationOpts = {
            title: 'Answers Added',
            message: ` Answers added to bid`,
            autoDismiss: 15,
          };
          dispatch(Notifications.success(notificationOpts));
          dispatch(answerAddSuccess());
          cb(response);
      } else{
        const notificationOpts = {
            title: 'Yikes!',
            message: 'Question is not added',
            autoDismiss: 15,
          };
          dispatch(Notifications.error(notificationOpts));
      }
    })
    .catch((error) => {
      if(error && typeof error.response !== 'undefined'){
        error.response.json().then((detail) => {
            dispatch(answerAddFailure());
        });
      }else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(createAnswers(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(answerAddFailure());
    });
  };
}

export function saveBidDetailsRates(id, payload) {
  return (dispatch) => {
    dispatch(requestingBidEdit(payload));
    return postBidDetailsRate(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestBidEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestBidEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editBid(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editBid(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBidEditFailure(payload));
      });
  };
}

export function getNotesBrand(id,payload,cb){
  return (dispatch) => {
    dispatch(requestGetNote(payload));
    return getBrandNote(id,payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestGetNoteSuccess(response));
        cb(response)
      })
      .catch((error)=>{
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestGetNoteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                dispatch(push('/login'));
            });
          }else if (status >= 404) {
            const notificationOpts = {
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(getNotesBrand(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else{
          const notificationOpts = {
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(getNotesBrand(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestGetNoteFailure(payload))
      })
  }
}

export function changeBrandStatus(id,payload,cb){
  return (dispatch) => {
    dispatch(requestChangeStatus(payload));
    return changeStatus(id,payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestChangeStatusSuccess(response));
        cb(response)
      })
      .catch((error)=>{
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestChangeStatusFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                dispatch(push('/login'));
            });
          }else if (status >= 404) {
            const notificationOpts = {
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(changeBrandStatus(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else{
          const notificationOpts = {
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(changeBrandStatus(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestChangeStatusFailure(payload))
      })
  }
}

export function addNotesBrand(id,payload,cb){
  return (dispatch) => {
    dispatch(requestAddNote(payload));
    return addNotes(id,payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestAddNoteSuccess(response));
        cb(response)
      })
      .catch((error)=>{
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestAddNoteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            return error.response.json().then((detail) => {
                dispatch(authLoginUserFailure(status, detail));
                dispatch(push('/login'));
            });
          }else if (status >= 404) {
            const notificationOpts = {
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(addNotesBrand(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else{
          const notificationOpts = {
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(addNotesBrand(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestAddNoteFailure(payload))
      })
  }
}

export function editBid(id, payload) {
  return (dispatch) => {
    dispatch(requestingBidEdit(payload));
    return patchBid(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestBidEditSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestBidEditFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editBid(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editBid(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBidEditFailure(payload));
      });
  };
}

export function addBidNote(id, payload) {
  return (dispatch) => {
    dispatch(requestingAddBidNote(payload));
    return fetchAddBidNote(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestAddBidNoteSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestAddBidNoteFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editBid(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editBid(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestAddBidNoteFailure(payload));
      });
  };
}
export function updateHotelContacts(bidId, payload,cb) {
  return (dispatch) => {
    dispatch(requestUpdateContact(payload));
    updateContact(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Update',
          message: 'Hotel Contact Update.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(receiveUpdateContact(response));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(updateHotelContacts(bidId, payload)),
              },
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'Ugh. Something is wrong. Try again in a bit.',
          autoDismiss: 0,
          action: {
            label: 'Retry',
            callback: () => dispatch(updateHotelContacts(bidId, payload)),
          },
        };
        return dispatch(Notifications.error(notificationOpts));
      });
  };
}

export function deleteHotelContacts(bidId, payload,cb) {
  return (dispatch) => {
    dispatch(requestDeleteContact(payload));
    deleteContact(bidId, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Update',
          message: 'Hotel Contact Update.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(receiveDeleteContact(response));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(deleteHotelContacts(bidId, payload)),
              },
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'Ugh. Something is wrong. Try again in a bit.',
          autoDismiss: 0,
          action: {
            label: 'Retry',
            callback: () => dispatch(deleteHotelContacts(bidId, payload)),
          },
        };
        return dispatch(Notifications.error(notificationOpts));
      });
  };
}
export function sendBid(bidId, payload) {
  return (dispatch) => {
    dispatch(requestBidSend(payload));
    const updatedPayload = {
      ...payload,
      AgentDetails: { email: "jccatchtest@gmail.com" }
    };
    fetchSendBookingBid(bidId, updatedPayload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Message Sent',
          message: 'Booking request is on its way.',
          autoDismiss: 10,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(receiveBidSend(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            console.log('Yikes problem with server. ', status);
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(sendBid(bidId, payload)),
              },
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Yikes!',
          message: 'Ugh. Something is wrong. Try again in a bit.',
          autoDismiss: 0,
          action: {
            label: 'Retry',
            callback: () => dispatch(sendBid(bidId, payload)),
          },
        };
        return dispatch(Notifications.error(notificationOpts));
      });
  };
}

export function updatePinUnpin(id, payload, cb) {
  return (dispatch) => {
    dispatch(requestPinUnpinStatusUpdate(payload));
    updatePinUnpinStatus(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const notificationOpts = {
          // uid: 'once-please', // you can specify your own uid if required
          title: 'Message Sent',
          message: 'Updating request is on its way.',
          autoDismiss: 1,
        };
        dispatch(Notifications.success(notificationOpts));
        dispatch(requestPinUnpinStatusUpdateSuccess(response));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              console.log('400: ', detail);
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(requestPinUnpinStatusUpdateFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(updatePinUnpin(id, payload, cb)),
              },
            };
            return dispatch(Notifications.error(notificationOpts));
          }
        }
      });
  };
}

export function requestBooking(payload) {
  return (dispatch) => {
    dispatch(requestingBooking());
    return fetchBooking(payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestBookingSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestBookingFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestBooking(payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestBooking(payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBookingFailure(payload));
      });
  };
}

export function getTour(cb) {
  return dispatch =>
    getTourStatusData()
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        cb(response)
        if (response.status === "Tour data got") {
          console.log("tour data got it");
        }
        dispatch(getTourSuccess());
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(getTourFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              action: {
                label: 'Retry',
                callback: () => dispatch(getTour()),
              },
            };
            //dispatch(Notifications.error(notificationOpts));
          }
        } else {
          const notificationOpts = {
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          //dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(getTourFailure());
      });
}

export function editTour(id, payload,cb) {
  return dispatch =>
    // dispatch(requestingBidEdit(payload));
    patchTourStatus(id, payload)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        cb(response)
        if (response.status === "Tour Status Changed") {
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Tour Archive',
            message: 'Tour is archived.',
            position: 'tr',
            autoDismiss: 10,
          };
          dispatch(Notifications.success(notificationOpts));
        }
        dispatch(editTourSuccess(response));
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(editTourFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(editTour(id, payload)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'We can not connect to the server. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(editEvent(id, payload)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(editTourFailure(payload));
      });
}

export function requestBookings(offset, searchTerm, statusSelected, startDateSelected, endDateSelected, cb) {
  return (dispatch) => {
    dispatch(requestingBookings());
    return fetchBookings(offset, searchTerm, statusSelected, startDateSelected, endDateSelected)
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(requestBookingsSuccess(response));
        cb(response)
      })
      .catch((error) => {
        if (error && typeof error.response !== 'undefined') {
          const status = error.response.status;
          if (status === 400) {
            error.response.json().then((detail) => {
              dispatch(requestBookingsFailure(detail));
            });
          } else if (status >= 401 && status <= 403) {
            // Invalid authentication credentials
            return error.response.json().then((detail) => {
              dispatch(authLoginUserFailure(status, detail));
              // const redirectAfterLogin = this.props.location.pathname;
              dispatch(push('/login'));
            });
          } else if (status >= 404) {
            const notificationOpts = {
              // uid: 'once-please', // you can specify your own uid if required
              title: 'Yikes!',
              message: 'Ugh. Something is wrong. Try again in a bit.',
              autoDismiss: 0,
              action: {
                label: 'Retry',
                callback: () => dispatch(requestBookings(offset, searchTerm, statusSelected, startDateSelected, endDateSelected, cb)),
              },
            };
            dispatch(Notifications.error(notificationOpts));
          }
        } else {
          // Most likely connection issues
          const notificationOpts = {
            // uid: 'once-please', // you can specify your own uid if required
            title: 'Yikes!',
            message: 'Ugh. Something is wrong. Try again in a bit.',
            autoDismiss: 0,
            action: {
              label: 'Retry',
              callback: () => dispatch(requestBookings(offset, searchTerm, statusSelected, startDateSelected, endDateSelected, cb)),
            },
          };
          dispatch(Notifications.error(notificationOpts));
        }
        return dispatch(requestBookingsFailure());
      });
  };
}
export function selectBooking(id) {
  return (dispatch) => {
    if (id !== 'undefined') {
      dispatch(requestBooking(id));
    }
    dispatch(requestingBookings());
    return {
      type: BOOKING_SELECT,
      payload: id,
    };
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BID_EDIT_REQUEST]: state => update(
    state,
    {
      selectedBooking:
      {
        isEditing:
        {
          $set: true,
        },
      },
    },
  ),
  [BID_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const bidList = state.selectedBooking.request.bids;
    const idx = bidList.findIndex(findById, id);
    if (idx === -1) {
      return update(state,
        {
          selectedBooking:
          {
            request:
            {
              bids:
                { $push: [action.payload] },
            },
          },
        });
    }
    return update(state,
      {
        selectedBooking:
        {
          request:
          {
            bids:
            {
              [idx]:
                { $set: action.payload },
            },
          },
        },
      });
  },
  [BIDNOTE_EDIT_REQUEST]: state => update(
    state,
    {
      selectedBooking:
      {
        isEditing:
        {
          $set: true,
        },
      },
    },
  ),
  [FETCH_ANSWERS_REQUEST]: (state, action) =>
    update(state, {
      selectedAnswers:{ $set :{isFetching: true, answers: [] }},
    }),
  [FETCH_ANSWERS_SUCCESS]: (state, action) =>
    update(state, {
      selectedAnswers:{
        $set:{answers: action.payload, isFetching: false}
      },
    }),
  [BIDNOTE_EDIT_SUCCESS]: (state, action) => {
    const id = action.payload.id;
    const bidList = state.selectedBooking.request.bids;
    const idx = bidList.findIndex(findById, id);
    if (idx === -1) {
      return update(state,
        {
          selectedBooking:
          {
            request:
            {
              bids:
                { $push: [action.payload] },
            },
          },
        });
    }
    return update(state,
      {
        selectedBooking:
        {
          request:
          {
            bids:
            {
              [idx]:
                { $set: action.payload },
            },
          },
        },
      });
  },
  [BOOKING_FETCH_REQUEST]: state => update(
    state,
    {
      selectedBooking:
      {
        $set:
        {
          needFetch: false,
          isFetching: true,
          request: {},
        },
      },
    },
  ),
  [BOOKING_FETCH_SUCCESS]: (state, action) => update(
    state,
    {
      selectedBooking:
      {
        $set:
        {
          needFetch: false,
          isFetching: false,
          hasError: false,
          request: action.payload,
        },
      },
    },
  ),
  [BOOKING_FETCH_FAILURE]: state => update(
    state,
    {
      selectedBooking:
      {
        $set:
        {
          needFetch: false,
          isFetching: false,
          hasError: true,
          request: {},
        },
      },
    },
  ),

  // state,
  //     {
  //       needFetch: { $set: false },
  //       isFetching: { $set: false },
  //       hasError: { $set: false },
  //       requests: { $push: action.payload }
  //     },
  [BOOKING_LIST_FETCH_SUCCESS]: (state, action) => update(
    state,
    {
      needFetch: { $set: false },
      isFetching: { $set: false },
      hasError: { $set: false },
      requests: { $push: action.payload.results },
      next: { $set: action.payload.next },
      selectedBooking: {
        needFetch: { $set: true },
        isFetching: { $set: false },
        hasError: { $set: false },
        request: { $set: {} },
      },
    },
  ),
  [BOOKING_LIST_FETCH_FAILURE]: state => update(
    state,
    {
      $set:
      {
        needFetch: false,
        isFetching: false,
        hasError: true,
        requests: [],
        selectedBooking: {
          needFetch: true,
          isFetching: false,
          hasError: false,
          request: {},
        },
      },
    },
  ),

  [BIDDETAIL_GET_SUCCESS]: (state, action) => {
    const idx = state.selectedBooking.request.bids.findIndex(findById, action.payload.bid)
    const newState = update(state,
      {
        selectedBooking:
        {
          request:
          {
            bids:
            {
              [idx]:
              {
                bid_bid_details:
                {
                  $set: action.payload.data
                }
              },
            },
          },
        },
      });

    console.log(newState);
    return newState;
  }
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  isFetching: false,
  needFetch: true,
  hasError: false,
  requests: [],
  next: "",
  selectedBooking: {
    request: {},
    isFetching: false,
    needFetch: true,
    hasError: false,
  },
};

export default function registerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}


// WEBPACK FOOTER //
// src/routes/booking/modules/booking.js